import React from 'react';
import { Box, Typography } from '@mui/material';
import { DeepseekSvg } from './DeepseekSvg';
import { ChatgptSvg } from './ChatgptSvg';
import { CoralSvg } from './CoralSvg';
import { FireSvg } from './FireSvg';

import { styles } from './styles';

export const AiCard = () => {
  return (
    <Box sx={styles.aiCard}>
      <Box sx={styles.fireIcon}>
        <FireSvg />
      </Box>
      <Typography
        variant="desktopH3"
        color="kit.text.orange"
        mb="6px"
        mt="-4px"
      >
        NEW
      </Typography>
      <Typography variant="kit.desktopP2" color="#ffffff" mb={4}>
        Обучаем как использовать AI в работе разработчика
      </Typography>
      <Box sx={styles.logos}>
        <DeepseekSvg />
        <ChatgptSvg />
        <CoralSvg />
      </Box>
    </Box>
  );
};
